export default "__VITE_ASSET__DW1d0sVI__"